import { Home } from 'lucide-react';
import { Link } from 'react-router';
import { AnimatedCubeIcon } from '@/components/animated/animated-cube-icon';
import { cn } from '@/lib/utils';

export function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gray-50">
      {/* Animated grid background */}
      <div
        className={cn(
          'absolute inset-0',
          '[background-size:60px_60px]',
          '[background-image:linear-gradient(to_right,#e5e7eb_1px,transparent_1px),linear-gradient(to_bottom,#e5e7eb_1px,transparent_1px)]',
        )}
      />

      {/* Radial gradient overlay for depth - fades edges to white */}
      <div className="pointer-events-none absolute inset-0 bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)]" />

      {/* Floating particles effect */}
      <div className="absolute inset-0 overflow-hidden">
        {Array.from({ length: 6 }, (_, i) => ({
          key: `particle-${i}`,
          left: `${15 + i * 15}%`,
          top: `${20 + (i % 3) * 25}%`,
          delay: `${i * 0.5}s`,
          duration: `${2 + i * 0.5}s`,
        })).map(({ key, left, top, delay, duration }) => (
          <div
            key={key}
            className="absolute h-2 w-2 rounded-full bg-gray-300 animate-pulse"
            style={{
              left,
              top,
              animationDelay: delay,
              animationDuration: duration,
            }}
          />
        ))}
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center px-6 text-center">
        {/* Cube with glow effect */}
        <div className="relative mb-8">
          <div className="absolute inset-0 blur-3xl opacity-20 bg-gradient-to-r from-pink-500 via-blue-500 to-yellow-500 scale-150" />
          <AnimatedCubeIcon size={120} className="relative" />
        </div>

        {/* 404 with gradient text */}
        <h1 className="mb-4 text-8xl font-black tracking-tighter md:text-9xl">
          <span className="bg-gradient-to-r from-pink-500 via-cyan-400 to-yellow-400 bg-clip-text text-transparent">
            404
          </span>
        </h1>

        {/* Playful message */}
        <h2 className="mb-3 text-2xl font-bold text-gray-900 md:text-3xl">
          Ops! Esta página se perdeu no cubo
        </h2>

        <p className="mb-8 max-w-md text-gray-500">
          Parece que você encontrou um portal para o vazio... Mas não se preocupe, podemos te levar
          de volta!
        </p>

        {/* Back to home button */}
        <Link
          to="/home"
          className={cn(
            'group inline-flex items-center gap-2 rounded-lg px-6 py-3 text-sm font-medium',
            'bg-gray-900 text-white shadow-lg',
            'transition-all duration-300',
            'hover:bg-gray-800 hover:scale-105 hover:shadow-xl',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400',
          )}
        >
          <Home className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          Voltar para o início
        </Link>

        {/* Subtle hint */}
        <p className="mt-12 text-xs text-gray-400">
          Se você acredita que isso é um erro, entre em contato com o suporte.
        </p>
      </div>
    </div>
  );
}
